import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  openProductDetailsAccordion: new analytics.Event({
    name: 'Product Details Accordion Opened',
    description: 'Merchant clicks the product details accordion for more info about product',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.CTA_CLICK,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['product'],
  }),
};
